import React from "react";

const Hero = () => {
  return (
    <section className="py-5 bg-gradient-primary text-white">
      <div className="container-fluid custom-container">
        <div className="row align-items-center">
          <div className="col-lg-7 mb-5 mb-lg-0 text-center text-lg-left">
            <h1 className="display-4 font-weight-bold mb-4">
              Get Recharge POS now - up to 4% cashback on recharges & bills!
            </h1>
            <p className="lead mb-4">
              Download the official Recharge POS APK directly from our secure
              servers and get instant recharges, utility payments, and up to 4%
              commissions on every transaction - all in one place!
            </p>

            <div className="warning-box p-4 mb-4 rounded">
              {/* <h5>
                <i className="fas fa-exclamation-triangle mr-2"></i>Important
                Notice
              </h5> */}
              <p className="mb-0">
                Download the official Recharge POS App – a 100% safe, secure,
                and trusted Indian app for seamless mobile recharges and bill
                payments!
              </p>
            </div>

            <div className="d-flex flex-column flex-sm-row">
              <a
                href="#download"
                className="btn btn-light btn-lg px-4 py-3 mr-sm-3 mb-3 animate__animated animate__pulse animate__infinite"
              >
                <i className="fas fa-download mr-2"></i>Download APK
              </a>
              <a
                href="#screenshots"
                className="btn btn-outline-light btn-lg px-4 py-3 mb-3"
              >
                <i className="fas fa-images mr-2"></i>View Screenshots
              </a>
            </div>
          </div>
          <div className="col-lg-5 text-center">
            <img
              src="/assets/images/rechargepos-app.gif"
              alt="App Preview"
              className="img-fluid"
              style={{
                maxWidth: "700px", // Increase image max width
                width: "100%", // Ensures responsiveness
                height: "auto", // Keeps aspect ratio
                objectFit: "contain", // Prevents distortion
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
